import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { ViError } from '@vi-iot/client';
import {
  AssistantDocumentDetails,
  AssistantFeedback,
  AssistantFilter,
  AssistantSearch,
  AssistantSuggestData,
} from '@vi-iot/client/apis/assistant/assistant.api-model';
import {
  AppServiceType,
  AssistantFeedbackPredefinedRanges,
  AssistantFeedbackSortOrder,
  AssistantFilterItem,
  AssistantFilterPayload,
  AssistantImages,
  AssistantOverlayTypeEnum,
} from './assistant.model';

export namespace AssistantAction {
  export const getFilters = createActionGroup({
    source: 'Assistant Get filters',
    events: {
      attempt: props<{
        searchText: string;
        filtersPayload: AssistantFilterPayload;
        init: boolean;
        app: AppServiceType;
      }>(),
      success: props<{ filters: AssistantFilter[] }>(),
      error: props<{ error: ViError }>(),
    },
  });

  export const setSearchQuery = createActionGroup({
    source: 'Assistant Set search query',
    events: {
      attempt: props<{ query: string }>(),
      success: props<{ query: string }>(),
      aborted: emptyProps(),
    },
  });

  export const setAssistantFilters = createActionGroup({
    source: 'Assistant Set filters',
    events: {
      attempt: props<{ filters: AssistantFilterItem[] }>(),
      success: props<{ filters: AssistantFilterItem[] }>(),
      aborted: emptyProps(),
      clear: emptyProps(),
    },
  });

  export const getSuggestions = createActionGroup({
    source: 'Assistant Get suggestions',
    events: {
      attempt: props<{ query: string; app: AppServiceType }>(),
      success: props<{ suggestions: AssistantSuggestData[] }>(),
      error: props<{ error: ViError }>(),
    },
  });

  export const searchForDocuments = createActionGroup({
    source: 'Assistant Search for documents',
    events: {
      attempt: props<{
        text: string;
        filtersPayload: AssistantFilterPayload;
        limit: number;
        app: AppServiceType;
      }>(),
      success: props<{ documents: AssistantSearch[]; totalCount: number }>(),
      fetch: props<{ maxItemsPerFetch: number; app: AppServiceType }>(),
      noDataToFetch: emptyProps(),
      error: props<{ error: ViError }>(),
    },
  });

  export const clearSearch = createAction('[Assistant] Clear search');

  export const selectDocument = createActionGroup({
    source: 'Assistant Select document',
    events: {
      setSearchDocument: props<{ document: AssistantSearch }>(),
      getContent: props<{ app: AppServiceType }>(),
      getContentSuccess: props<{ documentContent: string; app: AppServiceType }>(),
      getContentError: props<{ error: ViError }>(),
      getContentByDocumentId: props<{ documentId: string; app: AppServiceType }>(),
      getDocumentDetails: props<{ documentId: string; app: AppServiceType }>(),
      getDocumentDetailsWithUrlRedirection: props<{ documentId: string; app: AppServiceType }>(),
      getDocumentDetailsAborted: emptyProps(),
      getDocumentDetailsSuccess: props<{ documentDetails: AssistantDocumentDetails }>(),
      getDocumentDetailsWithUrlRedirectionSuccess: props<{
        documentDetails: AssistantDocumentDetails;
      }>(),
      getDocumentDetailsError: props<{ error: ViError }>(),
      getImages: props<{ app: AppServiceType }>(),
      getImagesAborted: emptyProps(),
      getImagesSuccess: props<{ images: AssistantImages[] }>(),
      getImagesError: props<{ error: ViError }>(),
      parseDocumentContent: props<{ documentContent: string }>(),
      clearState: emptyProps(),
    },
  });
  export const assistantFeedbackData = createActionGroup({
    source: 'Assistant documents feedback data',
    events: {
      attempt: emptyProps(),
      fetch: props<{ maxItemsPerFetch: number }>(),
      noDataToFetch: emptyProps(),
      success: props<{ feedbackData: AssistantFeedback[]; totalCount: number; limit: number }>(),
      error: props<{ error: ViError }>(),
      setSearch: props<{ search: string }>(),
      setFilterData: props<{
        filter: AssistantFeedbackPredefinedRanges;
        startDate: string;
        endDate: string;
        sortOrder: AssistantFeedbackSortOrder;
      }>(),
      clear: emptyProps(),
    },
  });

  export const changeOverlay = createAction(
    '[Assistant] Change overlay',
    props<{ overlay: AssistantOverlayTypeEnum }>()
  );

  export const setInitialState = createAction('[Assistant] Set initial state');
}
